import { render, staticRenderFns } from "./AddToGroupModal.vue?vue&type=template&id=771a6e03&scoped=true&"
import script from "./AddToGroupModal.vue?vue&type=script&lang=js&"
export * from "./AddToGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./AddToGroupModal.vue?vue&type=style&index=0&id=771a6e03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771a6e03",
  null
  
)

export default component.exports